import * as angular from "angular";
import {IController} from "angular";
import {
  RoutesMetadataSettingsModel,
  RoutesViewSettingsRouteModel,
  RoutesViewSettingsRoutesModel
} from "../../../models/routes-view-settings.model";

export class RoutesSettingsPanelTemplateComponent implements IController {

  showRoutes?: boolean;
  showStops?: boolean;
  routesSettings?: RoutesViewSettingsRoutesModel;
  tasksSettings?: RoutesViewSettingsRouteModel;
  isDrillDown?: boolean;
  panelRef: any;

  public routesSettingsCopy: RoutesViewSettingsRoutesModel;
  public tasksSettingsCopy: RoutesViewSettingsRouteModel;
  public enabledSections: {
    routesColumns: boolean;
    routeColumns: boolean;
    load: boolean;
    capacity: boolean;
    metadata: boolean;
  };

  $onInit() {
    this.routesSettingsCopy = angular.copy(this.routesSettings);
    this.tasksSettingsCopy = angular.copy(this.tasksSettings);
    this.enabledSections = {
      routesColumns: true,
      routeColumns: true,
      load: true,
      capacity: true,
      metadata: true,
    }
  }

  onChangeRoutesColumns(columnKey, isEnabled) {
    this.routesSettingsCopy.columns[columnKey] = isEnabled;
  }

  onChangeRouteColumns(columnKey, isEnabled) {
    this.tasksSettingsCopy.columns[columnKey] = isEnabled;
  }

  onChangeLoad(loadKey, isEnabled) {
    this.routesSettingsCopy.load[loadKey] = isEnabled;
    this.tasksSettingsCopy.load[loadKey] = isEnabled;
  }

  onChangeCapacity(loadKey, isEnabled) {
    this.routesSettingsCopy.capacity[loadKey] = isEnabled;
    this.tasksSettingsCopy.capacity[loadKey] = isEnabled;
  }

  onChangeMetadata(index, value) {
    this.routesSettingsCopy.metadata[index] = value;
  }

  onSubmit() {
    const payload = {
      routesSettings: this.routesSettingsCopy,
      tasksSettings: this.tasksSettingsCopy
    };
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', payload);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routesSettingsPanelTemplate', {
    bindings: {
      showRoutes: '<?',
      showStops: '<',
      routesSettings: '<?',
      tasksSettings: '<?',
      panelRef: '<'
    },
    template: require('./routes-settings-panel-template.html').default,
    controller: RoutesSettingsPanelTemplateComponent
  });
